import { Cache } from "aws-amplify/utils";
import { getUrl, uploadData } from "aws-amplify/storage";

// env var
const {
  REACT_APP_ARTICLE_CDN_BASEURL,
  REACT_APP_NODE_ENV,
  REACT_APP_AWS_ACCOUNT_ID,
  REACT_APP_REGION,
} = process.env;

// enums
export const ENUM_JOB_STATUS_TECH_ASSIG = 'TECHNICIAN:ASSIGNMENT';
export const ENUM_JOB_STATUS_JOB_INIT = 'JOB:INITIATED';
export const ENUM_JOB_STATUS_JOB_NAV_CREATED = 'JOB:ROUTE:CREATED';
export const ENUM_JOB_STATUS_JOB_NAV_INPROGRESS = 'JOB:ROUTE:INPROGRESS';
export const ENUM_JOB_STATUS_JOB_WORK_INPROGRESS = 'JOB:WORK:INPROGRESS';
export const ENUM_JOB_STATUS_JOB_COMPLETED_PAY_PENDING = 'JOB:COMPLETED:PAYMENT_TRANSFER:PENDING';
export const ENUM_JOB_STATUS_JOB_COMPLETED_PAY_COMPLETED = 'JOB:COMPLETED:PAYMENT_TRANSFER:COMPLETED';

export const classNames = (...classes) => {
  return classes.filter(Boolean).join(' ')
}

export const randomBackgroundColorForAvatar = () => {
  const options = [
    'bg-red-500',
    'bg-orange-500',
    'bg-yellow-500',
    'bg-green-500',
    'bg-teal-500',
    'bg-blue-500',
    'bg-indigo-500',
    'bg-purple-500',
    'bg-pink-500',
    'bg-slate-500',
    'bg-gray-500',
    'bg-zinc-500',
    'bg-neutral-500',
    'bg-stone-500',
    'bg-amber-500',
    'bg-lime-500',
    'bg-emerald-500',
    'bg-rose-500',
    'bg-fuchsia-500',
    'bg-violet-500',
    'bg-cyan-500',
    'bg-sky-500',
  ];

  const randomIndex = Math.floor(Math.random() * options.length);
  return options[randomIndex];
}

export const openAssetKeyNewTab = async (url) => {

  // find in cache
  const cache = await Cache.getItem(url);

  // chech
  if (cache) {
    const now = Math.floor(new Date().getTime() / 1000);
    const expired = Math.floor(new Date(cache.expired_at).getTime() / 1000);

    if (now < expired) {
      openNewBrowserTab(cache.signed_url);
      return cache.signed_url;
    }
  }

  const signedUrl = await getUrl({
    path: url,
    options: {
      expiresIn: 3600,
    }
  });
  const signed_url = signedUrl.url.toString();
  console.log('signed_url', signed_url);

  // save in cache
  await Cache.setItem(url, {
    signed_url: signed_url,
    expired_at: new Date(new Date().getTime() + 3600 * 1000).toISOString(),
  });

  openNewBrowserTab(signed_url);
  return signed_url;
}
 
const openNewBrowserTab = (url) => {
  const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
  if (newWindow) newWindow.opener = null
}

export const resolveLambdaArn = (serviceName, functionName) => {
  return `arn:aws:lambda:${REACT_APP_REGION}:${REACT_APP_AWS_ACCOUNT_ID}:function:${serviceName}-${functionName}-${REACT_APP_NODE_ENV}`;
}

export const slugify = (text = '') =>
  text.toLowerCase().trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 100);

export const isValidSlug = (slug = '') =>
  /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(slug) && slug.length <= 100;

/**
 * Uploads an article banner to S3 under public/articles/{resource_name}/{timestamp}.<ext>
 * and returns the public CloudFront URL to store in image_url.
 * Path must be under public/articles/ (admin role is scoped there).
 */
export const uploadArticleBanner = async (resourceName, file) => {
  const ext = (file.name.split('.').pop() || 'png').toLowerCase();
  const key = `public/articles/${resourceName}/${Date.now()}.${ext}`;

  await uploadData({
    path: key,
    data: file,
    options: { contentType: file.type },
  }).result;

  return {
    key,
    url: `${REACT_APP_ARTICLE_CDN_BASEURL}/${key}`,
  };
};

